import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Paper, Typography, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DateFormate } from "utils/DateFormate";
import axios from "config/axios";
import { handleAxiosResponseError } from "utils/handleResponseError";
import "./calender.css";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  paddingTop: theme.spacing(2),
  borderRadius: "0",
  textAlign: "center",
  color: "#000",
}));

export default function AgendaDrag({
  agendaList,
  setEventDetail,
  setDescOpen,
  dashboard = false,
}) {
  // React state to track order of items
  const [itemList, setItemList] = useState([]);

  function compare(a, b) {
    if (a.num < b.num) {
      return -1;
    }
    if (a.num > b.num) {
      return 1;
    }
    return 0;
  }

  useEffect(() => {
    setItemList(agendaList.sort(compare));
  }, [agendaList]);

  // console.log(agendaList);

  // Function to update list on drop
  const handleDrop = (droppedItem) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination) return;
    var updatedList = [...itemList];
    // Remove dragged item
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);

    updatedList = updatedList.map((li, key) => ({ ...li, num: key }));

    const data = updatedList;

    axios
      .put(`${process.env.REACT_APP_SERVER_URL}/api/calendar/updateorder`, data)
      .then(({ data }) => {
        console.log(data);
      })
      .catch((err) => console.log(handleAxiosResponseError(err)));

    // Update State
    setItemList(updatedList);
  };

  const handleAgenda = (index) => {
    setDescOpen(true);
    setEventDetail(itemList[index]);
  };

  // console.log(itemList);

  return (
    <DragDropContext onDragEnd={handleDrop}>
      <Droppable droppableId="list-container">
        {(provided) => (
          <div
            className="list-container"
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {itemList.map((item, index) => (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided) => (
                  <Item
                    ref={provided.innerRef}
                    {...provided.dragHandleProps}
                    {...provided.draggableProps}
                    className="border"
                  >
                    <div
                      className={
                        dashboard ? "dashboard-agenda-header" : "agenda-header"
                      }
                      onClick={() => handleAgenda(index)}
                    >
                      <Typography component="p" sx={{ fontSize: "17px" }}>
                        {item.title}
                      </Typography>
                      <Typography component="p" sx={{ fontSize: "17px" }}>
                        {DateFormate(item.dueDate)}
                      </Typography>
                    </div>
                    {item.users?.length ? (
                      <div className="d-flex flex-wrap">
                        <Typography
                          component="p"
                          variant="p"
                          fontSize={14}
                          fontWeight="bold"
                          sx={{ paddingLeft: "1px", paddingRight: "5px" }}
                          className="add-font"
                        >
                          Users:
                        </Typography>
                        {item.users?.map((user, index) => (
                          <Chip
                            key={index}
                            label={user.name}
                            size="small"
                            className="mr-1 mb-1"
                            sx={{
                              height: "20px",
                              "& span": { fontSize: "13px" },
                            }}
                          />
                        ))}
                      </div>
                    ) : (
                      ""
                    )}
                  </Item>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
